import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 39px;
  footer {
    clear: both;
    display: block;
    margin: 50px 0 0;

    div.footer-top {
      padding: 30px 20px;
      background-color: #f1f1f3;
      border: 0;
      font-family: inherit;
      font-size: 100%;
      font-style: inherit;
      font-weight: inherit;
      margin: 0;
      outline: 0;
      vertical-align: baseline;

      div.container {
        clear: both;
        width: 1140px;
        max-width: 100%;
        margin: 0 auto;
        padding-left: 0;
        padding-right: 0;

        div.row {
          margin-left: -225px;
          margin-right: -43px;
          margin-top: -30px;
          margin-bottom: 17px;

          div.col-lg-4 {
            padding-left: 30px;
            padding-right: 30px;
            width: 33.3%;
            float: left;
            position: relative;
            min-height: 1px;
            margin: 0;
            div.widget {
              clear: both;
              display: block;
              margin-bottom: 35px;

              div.horizontal {
                clear: both;
                display: block;
                text-align: center;
                ul {
                  display: block;
                  list-style: none;
                  margin: 0;
                  li {
                    text-align: -webkit-match-parent;
                    display: inline-block;
                    float: none;
                    list-style: none;
                    margin: 0 3%;
                    a {
                      font-size: 20px;
                      line-height: 20px;
                      color: #181819;
                      cursor: pointer;
                      -ms-word-break: break-all;
                      word-break: normal;
                      -webkit-transition: all .2s ease-out;
                      -moz-transition: all .2s ease-out;
                      transition: all .2s ease-out;
                      text-decoration: none;
                    }
                    .icon {
                      font-family: 'icomoon' !important;
                      speak: none;
                      font-style: normal;
                      font-weight: normal;
                      font-variant: normal;
                      text-transform: none;
                      line-height: 1;
                      -webkit-font-smoothing: antialiased;
                    }
                    .icon-twitter:before {
                      content: "\f099";
                      box-sizing: border-box;
                    }
                    .icon-facebook:before {
                      content: "\f09a";
                      box-sizing: border-box;
                    }
                    .icon-linkedin:before {
                      content: "\f0e1";
                      box-sizing: border-box;
                    }
                    .icon-instagram:before {
                      content: "\f16d";
                      box-sizing: border-box;
                    }
                    .icon-github:before {
                      content: "\f09b";
                      box-sizing: border-box;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    div.footer-bottom {
      clear: both;
      display: block;
      padding-bottom: 20px;
      text-align: center;
      background-color: #fff;
      a {
        display: inline-block;
        margin: 10px 0;
        font-size: 20px;
        line-height: 35px;
        color: #181819;
        text-decoration: none;
      }
      div.copy-right {
        padding: 10px;
        font-size: 12px;
        line-height: 14px;
        color: #181819;
        font-weight: 300;
      }
    }
  }
`;